import type { JSX } from 'react'
import type { IButtonGroupProps } from '../ButtonGroup'

import { ColumnGap, JustifyContent } from '../interfaces'
import { ButtonGroupSubscriptionStatusSC } from './ButtonGroupSubscriptionStatus.styled'

export interface IButtonGroupSubscriptionStatusProps extends IButtonGroupProps {}

export const ButtonGroupSubscriptionStatus = ({
  children,
  justifyContent = JustifyContent.Center,
  width = 100,
  wrap = true,
  columnGap = ColumnGap.INDENT_30,
  ...rest
}: IButtonGroupSubscriptionStatusProps): JSX.Element => (
  <ButtonGroupSubscriptionStatusSC
    justifyContent={justifyContent}
    width={width}
    wrap={wrap}
    columnGap={columnGap}
    {...rest}
  >
    {children}
  </ButtonGroupSubscriptionStatusSC>
)
